/**
 * How long the user waits for the first thing they can actually read in Editor.
 *
 * The selection read is instrumented from the moment it starts, which hides
 * everything before it: bundle parse, Office.js initialization, auth. The wait
 * that matters is measured from the moment the Editor is opened — not from pane
 * boot, which on a pane that has been sitting idle measures when the user
 * happened to click the tab rather than anything the code did.
 */
const bootAt = Date.now();
let editorOpenedAt: number | null = null;

/** Called when the Editor view mounts and starts seeding its selection. */
export function markEditorOpened(): void {
  editorOpenedAt = Date.now();
}

/**
 * Milliseconds the user waited for readable content, and whether this was the
 * pane's first view (in which case boot cost is part of the wait).
 */
export function editorPaintTiming(): { sinceOpen: number; sinceBoot: number } | null {
  if (editorOpenedAt == null) return null;
  const now = Date.now();
  return { sinceOpen: now - editorOpenedAt, sinceBoot: now - bootAt };
}
